<modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
    <p class="text is-marginless">Bien sûr, on ne va pas vous laisser comme ça !</p>
    <p class="text">Un conseiller vous rappelle en un clic pour finaliser votre commande.</p>

    <ng-template #customModalFooter>
        <button class="button is-conversion" (click)="close()">Me faire rappeler</button>
    </ng-template>
</modal>
